import { ClockIcon, TruckIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

const choices = [
  { isShipped: true, label: "Yes, I've shipped it", Icon: TruckIcon },
  { isShipped: false, label: "Not yet", Icon: ClockIcon },
];

interface ShippedChoiceProps {
  isShipped: boolean;
  onChange: (isShipped: boolean) => void;
}

export default function ShippedChoice({
  isShipped,
  onChange,
}: ShippedChoiceProps) {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mb-6">
      {choices.map(({ isShipped: value, label, Icon }) => (
        <button
          key={label}
          type="button"
          onClick={() => onChange(value)}
          className={clsx(
            "w-full py-6 px-4 border rounded-xl font-medium transition-all flex flex-col items-center justify-center gap-2 cursor-pointer",
            isShipped === value
              ? "bg-blue-50 border-blue-200 text-blue-700 shadow-sm"
              : "border-gray-300 text-slate-700 hover:bg-slate-50",
          )}
        >
          <Icon className="w-6 h-6" />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
